import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';
import { CdnIcon, Tip } from '@shared/ui';
export const Banner = ({ className, title, code, popular, variant = 'icon', type }) => {
    const { t } = useTranslation('InsurancePage');
    const { Banner: theme } = useTheme('InsurancePage');
    return (React.createElement("div", { className: cn(theme.banner, className, { [theme.withTitle]: variant === 'title' }), "data-insurance-program-code": code, "data-insurance-program-type": type }, variant === 'title' ? (React.createElement(React.Fragment, null,
        popular && React.createElement(Tip, { className: theme.popularBadge, variant: "popular", title: t('Most popular') }),
        React.createElement("div", { className: cn(theme.title, { [theme.isPopular]: popular }) }, title))) : (React.createElement("div", { className: theme.icons },
        popular && React.createElement(Tip, { className: theme.tip, variant: "popular", title: t('Most popular') }),
        React.createElement(CdnIcon, { icon: 'Services/Insurance' }),
        React.createElement(CdnIcon, { icon: 'Payment/Cash' })))));
};
